import { inject, InjectionToken } from '@angular/core';
import { DimensionLevelService } from './dimension-level.service';
import { ALWAYS_TOP_DIMENSION_LEVEL_SERVICE, CHECK_NEXT_DIMENSION_LEVEL_SERVICE } from './dimension-level.token';

export const DIMENSION_LEVEL_SERVICE = new InjectionToken<DimensionLevelService>('DIMENSION_LEVEL_SERVICE');

export function dataServiceFactory(): DimensionLevelService {
  const alwaysTopService = inject(ALWAYS_TOP_DIMENSION_LEVEL_SERVICE, { optional: true });
  const checkNextService = inject(CHECK_NEXT_DIMENSION_LEVEL_SERVICE, { optional: true });


  if (alwaysTopService) {
    return alwaysTopService;
  } else if (checkNextService) {
    return checkNextService;
  }

  throw new Error('No matching DimensionLevelService found');
}
